module.exports = __webpack_public_path__ + "img/estate.669bc3e0.jpg";